import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import { BsLine } from "react-icons/bs";
import { FaTiktok, FaInstagram } from "react-icons/fa";
import React, { Fragment } from "react";
import { useSearchParams } from "react-router-dom";

export default function Footer() {
  const [searchParams, setSearchParams] = useSearchParams();
  const displayLp = searchParams.get("display")
    ? searchParams.get("display")
    : undefined;
  return (
    <Fragment>
      {displayLp != "lp" && (
        <Box className="footer" component={"footer"}>
          <Container className="container">
            <Grid container>
              <Grid item md={6} sm={12}>
                <img
                  className="footer-logo"
                  src={"/images/footer-logo.png"}
                  alt=""
                />
                <Typography>© WONS inc All Rights Reserved.</Typography>
                <Box className="footer-social">
                  <a
                    href="https://instagram.com/nao_pcwork?igshid=NTc4MTIwNjQ2YQ=="
                    target="_blank"
                  >
                    <img
                      src={"/images/instagram.png"}
                      alt=""
                      className="footer-icon"
                    />
                  </a>

                  <a
                    href="https://www.tiktok.com/@nao_pcwork?_t=8f7yN5KUKcE&_r=1"
                    target="_blank"
                  >
                    <img
                      src={"/images/tiktok.png"}
                      alt=""
                      className="footer-icon"
                    />
                  </a>
                </Box>
                <a href="https://www.wons.co.jp/contact/" target="_blank">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "var(--text-color-3)",
                      color: "#fff",
                    }}
                    size="large"
                    className="btn-radius"
                  >
                    お問い合わせ
                  </Button>
                </a>
              </Grid>
              <Grid item md={6} sm={12}>
                <Grid
                  container
                  item
                  md={12}
                  sm={12}
                  className="mobile-margin-top"
                >
                  <Grid item md={6} sm={12} className="border-bottom-mobile">
                    <ul>
                      <li>
                        <a href="https://jibun-it.jp#staff" target="_blank">
                          経験豊富な相談員の特長
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp#flow" target="_blank">
                          ご利用の流れ
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp#support" target="_blank">
                          サポートについて
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp#plan" target="_blank">
                          料金プラン
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp#faq" target="_blank">
                          よくあるご質問
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.wons.co.jp/contact/"
                          target="_blank"
                        >
                          お問い合わせ
                        </a>
                      </li>
                    </ul>
                  </Grid>
                  <Grid item md={6} sm={12}>
                    <ul>
                      <li>
                        <a href="https://www.wons.co.jp/" target="_blank">
                          運営会社
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp/terms" target="_blank">
                          利用規約
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.wons.co.jp/privacypolicy/"
                          target="_blank"
                        >
                          プライバシーポリシー
                        </a>
                      </li>
                      <li>
                        <a href="https://jibun-it.jp/tokusho" target="_blank">
                          特商法について
                        </a>
                      </li>
                      <li>
                        <a href="https://113366.com/" target="_blank">
                          リモートサポート（予約者専用）
                        </a>
                      </li>
                    </ul>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
    </Fragment>
  );
}
